import React from "react";
import Slider from "react-slick";

function PaymentMethodCard({ method, isSelected, onSelect }) {
  const modeKind = method.displayModeKind || "new";
  const isManualStyle = modeKind === "manual" || modeKind === "manual_upi";

  return (
    <button
      type="button"
      className={`payment-method-card${
        isSelected ? " payment-method-card--selected" : ""
      }`}
      onClick={() => onSelect(method.id)}
      aria-pressed={isSelected}
      aria-label={method.displayTitle || method.provider}
    >
      <div className="payment-method-card__logo">
        {method.imagePath ? (
          <img src={method.imagePath} alt="" />
        ) : (
          <span className="payment-method-card__initial">
            {method.providerInitial}
          </span>
        )}
        <span className="payment-method-card__tagline">
          {method.displayTagline}
        </span>
      </div>

      <div className="payment-method-card__info" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
      }}>
        <span
          className="payment-method-card__title"
          title={method.displayTitle}
        >
          {method.displayTitle}
        </span>
        <span
          className={`payment-method-card__mode payment-method-card__mode--${modeKind}`}
        >
          {method.displayMode}
        </span>
      </div>

      <div
        className={`payment-method-card__icon payment-method-card__icon--${modeKind}`}
        aria-hidden="true"
      >
        <i
          className={`bi ${
            isManualStyle ? "bi-cash-coin" : "bi-credit-card-2-front"
          }`}
        />
      </div>
    </button>
  );
}

function PrevArrow({ className, onClick }) {
  return (
    <button
      type="button"
      className={`payment-method-slider__arrow payment-method-slider__arrow--prev ${className || ""}`}
      onClick={onClick}
      aria-label="Previous payment method"
    >
      <i className="bi bi-chevron-left" />
    </button>
  );
}

function NextArrow({ className, onClick }) {
  return (
    <button
      type="button"
      className={`payment-method-slider__arrow payment-method-slider__arrow--next ${className || ""}`}
      onClick={onClick}
      aria-label="Next payment method"
    >
      <i className="bi bi-chevron-right" />
    </button>
  );
}

export default function PaymentMethodSlider({
  methods = [],
  selectedId,
  onSelect,
}) {
  const activeMethods = methods.filter((method) => method.status);

  if (!activeMethods.length) return null;

  const settings = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 400,
    arrows: activeMethods.length > 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <div className="payment-method-slider">
      <Slider {...settings}>
        {activeMethods.map((method) => (
          <div key={method.id} className="payment-method-slide">
            <PaymentMethodCard
              method={method}
              isSelected={selectedId === method.id}
              onSelect={onSelect}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
